import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";
import { getAllCertificates } from "./certificateRequest";

export const certificatesAdapter = createEntityAdapter({
  selectId: (certificate) => certificate.id,
  sortComparer: (a, b) => (a.name || '').localeCompare(b.name || ''),
});


const initialState = {
  ...certificatesAdapter.getInitialState(),
}

const certificatesSlice = createSlice({
  name: 'certificateStore',
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addCase(getAllCertificates.fulfilled, (state, action) => {
        if (action?.payload) {
          certificatesAdapter.setMany(state, action.payload);
        }
      })
})

export default certificatesSlice;